// App-wide constants and configuration
import { 
  Home, User, Users, Building2, Shield, BookOpen, Video, Newspaper, Briefcase,
  FileSearch, Scale, MessageSquare, ShieldCheck, Award, Handshake, BarChart3,
  Mic, Star
} from 'lucide-react';

export const INDIAN_STATES = [
  "All India", "Maharashtra", "Karnataka", "Tamil Nadu", "Delhi NCR", 
  "Gujarat", "Telangana", "West Bengal", "Uttar Pradesh", "Rajasthan"
];

export const roleOptions = [
  { value: 'buyer', label: 'Buyer', icon: User, description: 'Property buyer' },
  { value: 'developer', label: 'Developer', icon: Building2, description: 'Builder' },
  { value: 'admin', label: 'Admin', icon: Shield, description: 'Administrator' },
];

// Value propositions for landing page - 60:40 Buyer-First, Developer-Fair
export const buyerBenefits = [
  { icon: Users, title: 'Connect with Fellow Buyers', description: 'Join a community of informed buyers in your project for collective strength' },
  { icon: FileSearch, title: 'Buyer Resources', description: 'Free checklists, red flag guides, and educational resources for informed decisions' },
  { icon: Scale, title: 'Know Your Rights', description: 'RERA resources and legal guidance to make informed, protected decisions' },
  { icon: MessageSquare, title: 'Transparent Communication', description: 'Structured channels ensuring clear, documented developer interactions' },
];

export const developerBenefits = [
  { icon: ShieldCheck, title: 'Transparency Partner Program', description: 'Voluntary disclosures that earn trust badges and buyer confidence' },
  { icon: Award, title: 'Recognition for Excellence', description: 'Good practices highlighted—on-time delivery, quality, communication' },
  { icon: Handshake, title: 'Right to Respond', description: 'Fair platform to address buyer concerns with your perspective' },
  { icon: BarChart3, title: 'Quality Buyer Leads', description: 'Connect with informed buyers who value transparent developers' },
];

// Speaker type configuration for videos
export const SPEAKER_CONFIG = {
  influencer: { icon: Mic, color: 'bg-pink-500', label: 'Influencer' },
  celebrity: { icon: Star, color: 'bg-amber-500', label: 'Celebrity' },
  builder: { icon: Building2, color: 'bg-emerald-500', label: 'Builder' },
  legal_expert: { icon: Scale, color: 'bg-purple-500', label: 'Legal Expert' },
  buyer_advocate: { icon: Users, color: 'bg-teal-500', label: 'Buyer Advocate' },
};

// Topic configuration for articles
export const TOPIC_CONFIG = {
  guide: { color: 'bg-blue-100 text-blue-700', label: 'Guide' },
  legal: { color: 'bg-purple-100 text-purple-700', label: 'Legal' },
  tips: { color: 'bg-amber-100 text-amber-700', label: 'Tips' },
  video: { color: 'bg-red-100 text-red-700', label: 'Video' },
  template: { color: 'bg-green-100 text-green-700', label: 'Template' },
};

// News source colors
export const NEWS_SOURCE_COLORS = {
  newspaper: 'bg-blue-100 text-blue-700',
  portal: 'bg-green-100 text-green-700',
  legal: 'bg-purple-100 text-purple-700',
  state: 'bg-amber-100 text-amber-700',
};

// Navigation sections - using actual icon components
export const publicSections = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'toolkit', label: 'Buyer Resources', icon: FileSearch },
  { id: 'education', label: 'Expert Guidance & Education', icon: Video },
  { id: 'buyer-resources', label: 'Free Buyer Resources & Legal Reference', icon: BookOpen },
  { id: 'news', label: 'Real Estate News & Analysis', icon: Newspaper },
  { id: 'professional', label: 'Professional Services', icon: Briefcase },
];

export const privateSections = [
  { id: 'project', label: 'My Project', icon: Home },
  { id: 'me', label: 'Me', icon: User },
  { id: 'us', label: 'Us', icon: Users },
];
